module.exports = __webpack_public_path__ + "public/img/[11_07_2023] Dasar Keselamatan dan Kesehatan Kerja di Tempat Kerja (2).cb5a6b72.png";